const firmware = {
  firmware: 'Micrologiciel',
  add_firmware: 'Nouveau micrologiciel',
  product_code: 'Code produit',
  version: 'Version',
  mandatory: 'Obligatoire',
  launch: 'Lancement',
  launched: 'Lancé',
  not_launched: 'Non lancé',
  add_success_msg: 'Micrologiciel ajouté avec succès',
  update_success_msg: 'Micrologiciel mis à jour avec succès',
  firmware_deleted: 'Micrologiciel supprimé',
  update_firmware: 'Mettre à jour le micrologiciel',
  upload_firmware: 'Télécharger le micrologiciel',
  install_firmware: 'Installer le micrologiciel',
  select_firmware_msg:
    'Sélectionnez le micrologiciel à installer et appuyez sur Continuer',
  confirm_update_msg:
    'Êtes-vous sûr de vouloir installer la version {{version}} du micrologiciel sur le contrôleur {{controller}} ?',
  confirm_update_r_msg:
    'Êtes-vous sûr de vouloir installer la version {{version}} du micrologiciel sur le lecteur {{reader}} ?',
  firmware_error_title: 'Erreur du Micrologiciel',
  error_learn_more: 'Erreur - En savoir plus',
  drag_drop: 'Glissez-déposez votre fichier ici ou',
  upload_a_file: 'Télécharger un fichier',
  table: {
    date: 'Date',
    controller: 'Contrôleur',
    reader: 'Lecteur',
    release: 'Note de publication',
  },
};

export default firmware;
